// extracted by mini-css-extract-plugin
export default {"searchTable":"DrmsSearch_searchTable__94JNh","keyword":"DrmsSearch_keyword__iArbo"};